export default __webpack_public_path__ + "static/media/9.ee2a7996.webp";